import { useState } from 'react';
import styles from './AddNote.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import UploadBox from '../../components/UploadBox/UploadBox';
import TextArea from '../../components/TextArea/TextArea';

import { FaFileAlt } from 'react-icons/fa';
import HeadingAndDropDown from '../../components/HeadingAndDropDown/HeadingAndDropDown';
import CheckboxAndData from '../../components/CheckboxAndData/CheckboxAndData';

const AddNote = () => {
  const dispatch = useDispatch();
  const [description, setDescription] = useState('');
  const [uploadedFile, setUploadedFile] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState('');
  const [isPrivate, setIsPrivate] = useState(false);
  const selectStaffOption = useSelector(
    (state) => state.modal.modalData?.selectStaffOption
  );
  console.log(selectStaffOption);

  const handleSave = () => {
    const noteData = {
      description,
      uploadedFile,
      selectedStaff,
      isPrivate,
    };
    console.log('Note Saved:', noteData);
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setDescription('');
    setUploadedFile(null);
    setSelectedStaff('');
    setIsPrivate(false);
    dispatch(closeModal());
  };

  return (
    <div className={styles.cardContainer}>
      {/* Header */}
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<FaFileAlt />}
          heading="Add New note"
          color="var(--Primary_Color)"
        />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      {/* Body */}
      <div className={styles.body}>
        {/* Description */}
        <div className={styles.formGroup}>
          <TextArea
            label="Add Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Add description"
            required
          />
        </div>

        {/* Staff Dropdown (Optional) */}
        {selectStaffOption && (
          <div className={styles.formGroup}>
            <HeadingAndDropDown
              label="Select staff (optional)"
              value={selectedStaff}
              onChange={(e) => setSelectedStaff(e.target.value)}
              options={[
                { label: 'John Jacob', value: 'john_jacob' },
                { label: 'Sarah Williams', value: 'sarah_williams' },
              ]}
              placeholder="Select staff"
            />
            <CheckboxAndData
              label="Mark private for selected staff"
              checked={isPrivate}
              onChange={(e) => setIsPrivate(e.target.checked)}
              checkboxSize={16}
              labelSize={14}
              labelColor={'var(--Grey_Color)'}
            />
          </div>
        )}

        {/* Upload */}
        <div className={styles.formGroup}>
          <UploadBox
            onChange={(e) => setUploadedFile(e.target.files[0])}
            label="Any document"
            innerLabel="Browse and upload files from device"
          />
        </div>

        {/* Actions */}
        <div className={styles.actions}>
          <SaveAndCancel
            onSave={handleSave}
            onCancel={handleCancel}
            saveLabel="Update"
            cancelLabel="Cancel"
          />
        </div>
      </div>
    </div>
  );
};

export default AddNote;
